// @flow

import type { TextContent } from '@chatchamp/chatchamp-types'

import { ChatBubbleMessageClass } from './ChatBubbleMessage'

export class ChatBubbleTextMessage extends ChatBubbleMessageClass<TextContent> {
  hasLinkPreview (): boolean {
    return !!this.getUrlFromText()
  }

  getUrlFromText (): string | null {
    const url = this.content.text.match(/\(([^)]+)\)\{:preview=true}/)
    return url ? url[1] : null
  }

  getNormalizedText (): string {
    return this.content.text.replace(/\{:preview=true}/, '')
  }
}
